const tocElement = document.getElementById("toc");
const headers = document.querySelectorAll("h2");
const header = document.getElementById("header");
const headerHeight = header.clientHeight;

const links = [];

function updateCurrentLinkClass() {
  const headerPositions = Array.from(headers).map(
    (element) =>
      Math.floor(element.getBoundingClientRect().top + window.scrollY) -
      headerHeight,
  );

  const currentPos = window.scrollY;

  links.forEach((link, index) => {
    const nextIndex = index + 1;
    const isCurrent =
      currentPos >= headerPositions[index] &&
      (nextIndex >= headers.length || currentPos < headerPositions[nextIndex]);

    if (isCurrent) {
      link.classList.add("is-current");
    } else {
      link.classList.remove("is-current");
    }
  });
}

function addIdToHeader(header, id) {
  header.id = id;
}

function createTocLinks(header, id) {
  const text = header.innerHTML;
  const listItem = document.createElement("li");
  const link = document.createElement("a");

  link.className = "c-toc__link";
  link.href = `#${id}`;
  link.innerHTML = text;

  listItem.appendChild(link);
  tocElement.appendChild(listItem);

  links.push(link);
}

window.addEventListener("DOMContentLoaded", () => {
  if (!tocElement) {
    return;
  }

  headers.forEach((header, index) => {
    const id = `index${index}`;
    addIdToHeader(header, id);
    createTocLinks(header, id);
  });

  window.addEventListener("scroll", updateCurrentLinkClass);
});
